module.exports = __webpack_public_path__ + "img/Schalke-04.69d1af8f.png";